import api from './api';
export const WalmartService = {
    searchProducts(query, limit = 10) {
        return api.get('/api/walmart/products', { params: { query, limit } });
    },
    searchOrders(email, limit = 10) {
        return api.get('/api/walmart/orders', { params: { email, limit } });
    },
};
